import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useContent } from "@/content/ContentContext";

const titles = { impressum: "Impressum", datenschutz: "Datenschutzerklärung" };

export const LegalOverlay = ({ open, onClose }) => {
  const content = useContent();

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const blocks = open ? content.legal[open] : null;

  return (
    <AnimatePresence>
      {blocks && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-background/90 p-4 backdrop-blur-md"
          onClick={onClose}
          data-testid="legal-overlay"
        >
          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 40, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="max-h-[80vh] w-full max-w-2xl overflow-y-auto border border-foreground/10 bg-card p-8 md:p-12"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-8 flex items-start justify-between gap-4">
              <h3 className="font-heading text-3xl font-black tracking-tight text-foreground">
                {titles[open]}
              </h3>
              <button
                onClick={onClose}
                data-testid="legal-close-button"
                aria-label="Schließen"
                className="rounded-full border border-foreground/15 p-2 text-muted-foreground transition-colors duration-300 hover:border-primary hover:text-primary"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div data-testid={`${open}-content`} className="space-y-8">
              {blocks.map((b, i) => (
                <div key={i}>
                  <h4 className="mb-2 font-mono text-xs uppercase tracking-[0.25em] text-primary">
                    {b.h}
                  </h4>
                  {b.p.filter(Boolean).map((line, j) => (
                    <p
                      key={j}
                      className="text-sm leading-relaxed text-muted-foreground"
                    >
                      {line}
                    </p>
                  ))}
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
